import React, { useState } from "react";
import dynamic from "next/dynamic";
import UserAvatarIcon from "../../../public/IconComponents/UserAvatarIcon";
import { ChevronDown } from "@/public/Theme";

const DashboardSmallMenu = dynamic(
    () => import("../DashboardSidebar/DashboardSmallMenu"),
    { ssr: false }
);

const UserInitialsAvatar = ({ userData }) => {
    const [open, setOpen] = useState(false);

    return (
        <div
            className={
                "w-full  flex items-center justify-center relative gap-[4px]"
            }
        >
            {/* Avatar Container */}

            <div
                className="w-[32px] h-[32px] flex items-center justify-center"
                onClick={() => setOpen((prev) => !prev)}
            >
                <UserAvatarIcon invert={open} />
            </div>

            {/* Chevron Icon */}
            <img
                className={`transition-transform delay-100 ml-[4px] ${
                    open ? "rotate-180" : ""
                }`}
                src={ChevronDown}
                onClick={() => setOpen((prev) => !prev)}
            />

            {/* Overlay for closing the menu */}
            {open && (
                <div
                    onClick={() => setOpen(false)}
                    className="fixed z-[600] h-screen right-0 top-0 w-screen"
                ></div>
            )}

            {/* Dashboard Menu */}
            <DashboardSmallMenu
                userData={userData}
                setOpen={setOpen}
                open={open}
            />
        </div>
    );
};

export default UserInitialsAvatar;
